/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var minilo = require('../util/minilo');
var style = _interopDefault(require('./style'));

var props = {
  snapToPixel: {
    type: Boolean,
    default: true
  }
};

var methods = {
  /**
   * @return {Promise}
   * @protected
   */
  init: function init() {
    return style.methods.init.call(this);
  },

  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit: function deinit() {
    return style.methods.deinit.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    this.$stylesContainer && this.$stylesContainer.setImage(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    this.$stylesContainer && this.$stylesContainer.setImage(undefined);
  },

  /**
   * @return {Object}
   * @protected
   */
  getServices: function getServices() {
    return style.methods.getServices.call(this);
  },

  /**
   * @return {Promise}
   */
  refresh: function refresh() {
    // recreate style
    return this.recreate();
  }
};

var watch = {
  snapToPixel: function snapToPixel(value) {
    if (this.$style && !minilo.isEqual(value, this.$style.getSnapToPixel())) {
      this.scheduleRefresh();
    }
  }
};

var imageStyle = {
  mixins: [style],
  props: props,
  methods: methods,
  watch: watch,
  stubVNode: {
    empty: false,
    attrs: function attrs() {
      return {
        class: this.$options.name
      };
    }
  }
};

module.exports = imageStyle;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/image-style.js
// module id = 167
// module chunks = 1